// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDAIHw4nlwQL4n4CIGcEzIMndA-vrkL7VE",
  authDomain: "xinchuan2-dcd2c.firebaseapp.com",
  projectId: "xinchuan2-dcd2c",
  storageBucket: "xinchuan2-dcd2c.firebasestorage.app",
  messagingSenderId: "672010732455",
  appId: "1:672010732455:web:d4fd08d82a0c956c7bac82",
  measurementId: "G-R7F06795CR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };
